/*!
 * Centralize this so we can more easily work around issues with people
 * stubbing out `process.nextTick()` in tests using sinon:
 * https://github.com/sinonjs/lolex#automatically-incrementing-mocked-time
 * See gh-6074
 */

'use strict';

module.exports = function immediate(cb) {
  return process.nextTick(cb);
};



//////////////////
// WEBPACK FOOTER
// ./~/mongoose/lib/helpers/immediate.js
// module id = 448
// module chunks = 0